import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { PATH_CLOCK_LOGS } from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'
import { notifyError, notifySuccess } from '@/lib/notifications'

const clockLogs = {
  namespaced: true,
  state: buildInitialState({
    clockWeekLogs: {
      assignmentId: null,
      clockDaysLog: []
    }
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setClockWeekLogs: (state, clockWeekLogs) => {
      state.clockWeekLogs = clockWeekLogs
    }
  },
  actions: {
    getClockWeekLogs: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting time log, please wait...' })

      return api.doGet({ path: PATH_CLOCK_LOGS, parameters: filters })
        .then(json => json.data)
        .then(clockWeekLogs => {
          commit('updateStatus', { status: COMPLETE })
          commit('setClockWeekLogs', clockWeekLogs)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get time log. Try again later')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    clock: ({ commit, dispatch }, log) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: `Clocking ${log.state === 0 ? 'In' : 'Out'}, please wait...` })

      return api.doPost({ path: PATH_CLOCK_LOGS, data: log })
        .then(json => json.data)
        .then(clockWeekLogs => {
          commit('updateStatus', { status: COMPLETE })
          if (!clockWeekLogs) {
            throw new Error(`Unable to clock ${log.state === 0 ? 'in' : 'out'}. Try again`)
          } else {
            notifySuccess(dispatch, `Clocked ${log.state === 0 ? 'in' : 'out'} successfully`)
            return clockWeekLogs
          }
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, `Unable to clock ${log.state === 0 ? 'in' : 'out'}. Try again`)
          return null
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default clockLogs
